import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCanvasDraftCreated.meta';

export type UseTrackCanvasDraftCreatedParams = {
  source?:
    | 'board'
    | 'library'
    | 'general_library'
    | 'asset_selection_bar'
    | 'all_content_header'
    | 'canvases'
    | 'try_canvas_cta'
    | 'board_canvas_open'
    | 'all_content_canvas_open';
  board_id?: string;
  library_id?: string;
};

export const useTrackCanvasDraftCreated = () => {
  const { track } = useAnalyticsUtilities();

  const trackCanvasDraftCreated = useCallback(
    (params: UseTrackCanvasDraftCreatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCanvasDraftCreated };
};
